import { Node as ProsemirrorNode } from '@tiptap/pm/model'
import { EditorView } from '@tiptap/pm/view'

export type FixFn = (view: EditorView, issue: Result) => void

export interface Result {
  level: 'error' | 'warning' | 'suggestion'
  message: string
  from: number
  to: number
  type: 'node' | 'inline'
  fix?: FixFn
}

export default class LinterPlugin {
  protected doc
  public props

  private results: Array<Result> = []

  constructor(doc: ProsemirrorNode, props: unknown) {
    this.doc = doc
    this.props = props
  }

  record(
    level: Result['level'],
    message: string,
    from: number,
    to: number,
    type: Result['type'] = 'inline',
    fix?: FixFn
  ) {
    this.results.push({
      level,
      message,
      from,
      to,
      type,
      fix,
    })
  }

  scan() {
    return this
  }

  getResults() {
    return this.results
  }
}
